// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HistoryOutlinedSvg from "@fishx/icons-svg/es/asn/HistoryOutlined";
import FishxIcon from '../components/FishxIcon';

var HistoryOutlined = function HistoryOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HistoryOutlinedSvg
  }));
};

HistoryOutlined.displayName = 'HistoryOutlined';
export default React.forwardRef(HistoryOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HistoryOutlined.js
// module id = 2934
// module chunks = 0